import { FormField, Header } from '@/components/SettingsLayout';
import {
  SkeletonButton,
  SkeletonHeader,
  SkeletonSmallField,
} from '@/components/SkeletonLoader/SkeletonElements';
import { Divider } from '@/ui';

const CompanySkeleton = () => {
  return (
    <>
      <Header>
        <SkeletonHeader />
      </Header>
      <Divider color='dark' />
      <Header>
        <SkeletonHeader />
      </Header>
      <FormField>
        <SkeletonSmallField />
        <SkeletonSmallField />
      </FormField>
      <FormField>
        <SkeletonSmallField />
        <SkeletonSmallField />
      </FormField>
      <FormField>
        <SkeletonSmallField />
        <SkeletonSmallField />
      </FormField>
      <FormField>
        <SkeletonSmallField />
        <SkeletonSmallField />
      </FormField>
      <Header>
        <SkeletonHeader />
      </Header>
      <FormField>
        <SkeletonSmallField />
        <SkeletonSmallField />
      </FormField>
      <FormField>
        <SkeletonSmallField />
        <SkeletonSmallField />
      </FormField>
      <FormField>
        <SkeletonSmallField />
        <SkeletonSmallField />
      </FormField>
      <FormField>
        <SkeletonSmallField />
        <SkeletonSmallField />
      </FormField>
      <FormField>
        <SkeletonSmallField />
        <SkeletonSmallField />
      </FormField>
      <FormField>
        <SkeletonSmallField />
        <SkeletonSmallField />
      </FormField>
      <FormField>
        <SkeletonSmallField />
        <SkeletonSmallField />
      </FormField>
      <Divider color='dark' />
      <FormField className='footer'>
        <SkeletonButton />
        <SkeletonButton />
      </FormField>
    </>
  );
};

export default CompanySkeleton;
